import { RouteStrategy } from './routeStrategy';

const unauthenticatedRouteStrategies = {
  registrationRoute: new RouteStrategy(
    (context) => {
      const { deeplinkPath, deeplinkPathSet } = context;
      return (
        deeplinkPath && Array.from(deeplinkPathSet).some((path) => deeplinkPath?.includes(path))
      );
    },
    (context) => context.deeplinkPath,
    40,
  ),

  logoutRedirect: new RouteStrategy(
    (context) => context.redirectToLogin,
    () => '/register/login',
    30,
  ),

  default: new RouteStrategy(
    () => true,
    () => '/register/login',
    0,
  ),
};

export default unauthenticatedRouteStrategies;
